const Row = (props) => {
  const { id, cells, model } = props

  return (
    <tr id={id ? cells[id] : null}>
      { model
        ? Object.keys(model).map((key) => {
          const { accessor, cell: customCell } = model[key]
          return (
            <td class={`qa-${accessor}`}>
              {customCell ? customCell(cells) : cells[accessor]}
            </td>
          )
        })
        : Object.keys(cells).map((key) => {
          return (<td colspan={cells[key].hasOwnProperty('colspan') ? cells[key].colspan : undefined}
            class={`qa-${cells[key].hasOwnProperty('accessor') ? cells[key].accessor : key}`}>
            {cells[key].hasOwnProperty('cell') ? cells[key].cell : cells[key]}
          </td>)
        })
      }
    </tr>
  )
}

export default Row
